import { createSlice } from "@reduxjs/toolkit";
import {
    fetchQuestionCategoryTableColumnNames,
    fetchAllQuestionCategory,
    createQuestionCategory,
    updateQuestionCategory,
    deleteQuestionCategory,
    activateDeactivateQuestionCategory,
    uploadQuestionCategoryIcon
} from "./thunk";
import { toast } from "react-toastify";

const questionCategorySlice = createSlice({
  name: "QuestionCategory",
  initialState: {
    icon: "",
    questionCategory: [],
    tableColumnNames: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder

      // Fetch Question Category Table Column Names
      .addCase(fetchQuestionCategoryTableColumnNames.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuestionCategoryTableColumnNames.fulfilled, (state, action) => {
        state.loading = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchQuestionCategoryTableColumnNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get All Question Category
      .addCase(fetchAllQuestionCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllQuestionCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.questionCategory = action.payload;
      })
      .addCase(fetchAllQuestionCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Question Category
      .addCase(createQuestionCategory.pending, (state) => {
        state.error = null;
      })
      .addCase(createQuestionCategory.fulfilled, (state, action) => {
        state.questionCategory = [action.payload.data[0], ...state.questionCategory];
        toast.success(action.payload.message);
      })
      .addCase(createQuestionCategory.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Update Question Category
      .addCase(updateQuestionCategory.pending, (state) => {
        state.error = null;
      })
      .addCase(updateQuestionCategory.fulfilled, (state, action) => {
        const index = state.questionCategory.findIndex(
          (item) => item.ID === action.payload[0].ID
        );

        if (index !== -1) {
          state.questionCategory[index] = action.payload[0];
        }

        toast.success("Updated successfully");
      })
      .addCase(updateQuestionCategory.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Delete Question Category
      .addCase(deleteQuestionCategory.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteQuestionCategory.fulfilled, (state, action) => {
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.questionCategory = state.questionCategory.filter(
          (item) => !deletedIds.includes(item.ID)
        );

        toast.success("Deleted successfully");
      })
      .addCase(deleteQuestionCategory.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Active Deactive Question Category
      .addCase(activateDeactivateQuestionCategory.pending, (state) => {
        state.error = null;
      })
      .addCase(activateDeactivateQuestionCategory.fulfilled, (state, action) => {
        if (action.payload) {
          const updatedQuestionCategory = action.payload[0];

          state.questionCategory = state.questionCategory.map((item) => item.ID === updatedQuestionCategory.ID ? {...item, IsActive: updatedQuestionCategory.IsActive} : item)
        }
      })
      .addCase(activateDeactivateQuestionCategory.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(uploadQuestionCategoryIcon.fulfilled, (state, action) => {
        state.icon = action.payload;
      })
      .addCase(uploadQuestionCategoryIcon.rejected, (state, action) => {
        state.error = action.payload;
      })
    },
});

export default questionCategorySlice.reducer;
